import CWSite from "../assets/images/cw-site.png"

const clipweb_site = {
    slug: "Clip_Web_Site",
    sections: [
        {
            elements: [
                { type: "title-prc", content: "Site web Clip Web" },
                { type: "tex-prc", content: "Développement complet de mon site vitrine professionnel avec React : de la maquette au déploiement, en passant par le SEO et la promotion digitale." },
                { type: "imageTitle", src: CWSite, alt: "Site web Clip Web - Page d'accueil" }
            ]
        },
        {
            elements: [
                { type: "title", content: "Genèse du projet" },
                { type: "text", content: "Le site web Clip Web représente la vitrine digitale de mon activité de freelance. L'objectif était de créer un espace professionnel permettant de présenter mes services, mon portfolio et de faciliter la prise de contact avec des clients potentiels. Ce projet personnel m'a permis d'appliquer l'ensemble de mes compétences en design et développement web." }
            ]
        },
        {
            elements: [
                { type: "title", content: "Phase de conception et design" },
                { type: "text", content: "Avant toute ligne de code, j'ai consacré un temps important à la phase de conception. J'ai créé des maquettes détaillées pour chaque page du site, en réfléchissant à l'expérience utilisateur et au parcours de navigation. Parallèlement, j'ai développé une charte graphique complète définissant les couleurs, typographies, espacements et styles visuels qui allaient composer l'identité visuelle de Clip Web." }
            ]
        },
        {
            elements: [
                { type: "title", content: "Création du logo" },
                { type: "text", content: "Le logo Clip Web a été conçu pour refléter mon approche du développement web : moderne, dynamique et précise. Les formes et couleurs choisies évoquent à la fois la technologie et la créativité. Ce logo décline sur tous les supports de communication et renforce la cohérence de mon identité de marque." }
            ]
        },
        {
            elements: [
                { type: "title", content: "Développement avec React" },
                { type: "text", content: "Le site a été développé avec React pour bénéficier d'une architecture moderne et performante. J'ai mis en place une structure de composants réutilisables, des animations fluides et une navigation intuitive. Le code est organisé et optimisé pour faciliter les futures évolutions et garantir une maintenance aisée." }
            ]
        },
        {
            elements: [
                { type: "title", content: "Stratégie SEO" },
                { type: "text", content: "Une attention particulière a été portée au référencement naturel (SEO) pour maximiser la visibilité du site sur les moteurs de recherche. J'ai optimisé la structure HTML sémantique, les balises meta, les temps de chargement et le contenu textuel. Les images sont compressées et correctement balisées. Cette stratégie permet à Clip Web d'apparaître dans les résultats de recherche pour des requêtes pertinentes liées au développement web freelance." }
            ]
        },
        {
            elements: [
                { type: "title", content: "Responsive design" },
                { type: "text", content: "Le site est entièrement responsive et adapté à tous les types d'écrans : desktop, tablette et mobile. Chaque composant a été pensé pour offrir une expérience optimale quel que soit le dispositif utilisé. Les images s'adaptent, les menus se transforment et les espacements s'ajustent automatiquement." }
            ]
        },
        {
            elements: [
                { type: "title", content: "Promotion sur les réseaux sociaux" },
                { type: "text", content: "Pour développer la visibilité du site, j'ai mis en place une stratégie de promotion sur les réseaux sociaux professionnels. Le site a été partagé sur Facebook et LinkedIn, accompagné de contenus présentant mes services et mes réalisations. Cette approche multicanale permet de toucher différents publics et de générer du trafic qualifié vers le site." }
            ]
        },
        {
            elements: [
                { type: "title", content: "Résultat et évolution" },
                { type: "text", content: "Le site Clip Web est aujourd'hui opérationnel et constitue mon principal outil de prospection et de présentation professionnelle. Il regroupe mon portfolio, mes services, mes témoignages clients et mes coordonnées. Le site évolue régulièrement avec l'ajout de nouveaux projets et l'amélioration continue des fonctionnalités." }
            ]
        }
    ]
};

export default clipweb_site;